import ga from "@toolkit/Framework/Common/GoogleAnalytics";
import { TrackEventListParameters } from "@toolkit/Framework/Common/GoogleAnalytics/trackers/trackEventList";

/* ---------------------------------------------------------------------------------------------------- */
// Toolkit Custom Event
/* ---------------------------------------------------------------------------------------------------- */

export interface TrackQuoteSubmittedItem extends Toolkit.GoogleAnalytics.AnyProductItem {}

export interface TrackQuoteSubmittedParameters
    extends TrackEventListParameters<"has_notes" | "type", null, TrackQuoteSubmittedItem> {}

const trackQuoteSubmitted = (parameters: TrackQuoteSubmittedParameters, options?: Toolkit.GoogleAnalytics.Options) => {
    return ga.track.eventList({ action: "quote_submitted", ...parameters }, options);
};

export default trackQuoteSubmitted;
